import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { LoadingService } from '@shared/loading';
import { debounceTime, filter, map, switchMap, tap } from 'rxjs/operators';
import { OlvidePasswordService } from './services/olvide-password.service';

@Component({
  selector: 'app-olvide-password',
  templateUrl: './olvide-password.component.html',
  styleUrls: ['./olvide-password.component.scss'],
})
export class OlvidePasswordComponent implements OnInit {

  correoControl: FormControl = new FormControl('', [Validators.required, Validators.email]);
  correoEnviado = false;
  correoEncontrado: boolean;

  constructor(
    private _modalController: ModalController,
    private _olvidePasswordService: OlvidePasswordService,
    private  _loadingService: LoadingService,
    private _router: Router
  ) { }

  ngOnInit() {
    this.correoControl
      .valueChanges.pipe(
        tap(() => {
          this.correoEncontrado = false;
        }),
        debounceTime(1000),
        map((value) => value?.trim()),
        filter((value) => value?.length > 0),
        switchMap((value) => this._olvidePasswordService.comprobarCorreo(value))
      )
      .subscribe((noEncontrado) => {
        if (noEncontrado) {
          this.correoControl.setErrors({
            emailTaken: true,
            mensajeError: 'No existe una cuenta con este correo'
          });
        } else {
          this.correoEncontrado = true;
        }
      });
  }

  retablecerPassword(){
    this._loadingService.isLoading = true;
    this._olvidePasswordService.forgotPassword(this.correoControl.value).subscribe(() => {
      this.correoEnviado = true;
      this._loadingService.isLoading = false;
    });
  }

  cerrar(){
    this._modalController.dismiss();
  }

  irLogin(){
    this.cerrar();
    this._router.navigate(['/sign-in']);
  }

}
